<!--<div class="header-container container-fluid pb-3" [ngStyle]='{"padding-left":leftMargin}' style="min-height: 100px;"
  *ngIf='showHeader'>
  <div class="row justify-content-center g-0 pt-3 ">
    <div class="col-md-11">
      <div class="row align-items-center">
        <div class="col-4 d-inline d-md-none">
        </div>
        <div class="col-4 d-md-inline d-none">
          <div class="">
            <div class="">
              <p class="break-newline" style="margin-right: 3%;" [innerHTML]="rightText"></p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center title">
            <img [src]='centerLogoUrl' height="50">
          </div>
        </div>
        <div class="col-4 d-md-inline d-none">
          <span class="title float-right" style="margin-left: 3%;">
            <span class='align-middle mt-1'>{{leftText}}</span>
            &nbsp;&nbsp;&nbsp;
            <span class='ps-icons icon-debrain' *ngIf="company==Company.DEBRAIN"
              style="font-size: 20px; color:turquoise !important;" height="20"></span>
            <span class='prp-icons icon-m3m-logo' *ngIf="company==Company.M3M"
              style="font-size: 20px; color:#2AA5F5!important;" height="20"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>-->

<meta name="viewport" content="width=device-width, initial-scale=1.0">


<nav
  [ngClass]="(isPageSmall && isPageVertical) ? 'navbar navbar-small d-xl-none unselectable':'navbar-h navbar-small-h d-xl-none unselectable'">


  <button [ngClass]="(isPageSmall && isPageVertical) ? 'navbar-toggler':'navbar-toggler-h'" type="button"
    aria-label="Toggle navigation" (click)='isCollapsed=!isCollapsed'>
    <span [ngClass]="(isPageSmall && isPageVertical) ? 'navbar-toggler-img':'navbar-toggler-img-h'"
      [ngStyle]="{opacity:(isCollapsed) ? 1 : 0}">
      <img src="assets/icons/burger.svg" alt="show">
    </span>
    <span [ngClass]="(isPageSmall && isPageVertical) ? 'navbar-toggler-img':'navbar-toggler-img-h'"
      [ngStyle]="{opacity:(isCollapsed) ? 0 : 1}">
      <img src="assets/icons/cross.svg" alt="hide">
    </span>
  </button>


  <span class="prp-icons">
    <img src="assets/img/Logo Vertical.svg" *ngIf="isPageSmall && isPageVertical" alt="show" style="height: 30px;">
  </span>

  <span class="prp-icons" *ngIf="company==Company.DEBRAIN">
    <img src="assets/icons/debrain_red_big.png" alt="logo" 
    [ngStyle]="(isPageSmall && isPageVertical) ? {'height': '30px'} : {'height': '30px', 'margin-top': '200px', 'margin-left': '15%'}">
  </span>
  <span class="prp-icons" *ngIf="company==Company.M3M">
    <img src="assets/icons/logo_m3m.png" alt="logo"
      [ngStyle]="(isPageSmall && isPageVertical) ? {'height': '30px'} : {'height': '30px', 'margin-top': '200px', 'margin-left': '15%'}">
  </span>

  <div [ngClass]="(isPageSmall && isPageVertical) ? 'mobile-menu':'mobile-menu-h'" id='headerToggler'
    style="overflow: auto;"
    [ngStyle]="{opacity:(isCollapsed) ? 0 : 1, visibility:(isCollapsed) ? 'collapse' : 'visible'}">

    <div class="info">
      <div class="row">
        <div class="col-10">
          <span *ngIf="bookStudies && bookStudies.length > 0">{{bookStudies[0].patientName}}</span>
        </div>
        <div class="col-2">
          <button *ngIf="isPageSmall && !isPageVertical" type="button" class="close" aria-label="Close"
            (click)='isCollapsed=!isCollapsed'>
            <span aria-hidden="true" style="color: #A3ACBF;">&times;</span>
          </button>
        </div>
      </div>
      <div class="row">
        <span *ngIf="bookStudies && bookStudies.length > 0" style="color:var(--golden);">{{bookStudies[0].description}}</span>
        <span *ngIf="bookStudies && bookStudies.length > 0" style="color: var(--golden);">Fecha del estudio: {{bookStudies[0].studyDate |
          date:'dd/MM/yyyy'}}</span>
      </div>

    </div>

    <div class="row " *ngIf="permissionService.hasPermission(TokenPermissions.DOWNLOAD)"
      (click)='showDownloadModes=!showDownloadModes'>

      <div class="col-2">
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.5 0V7.5H2.5L10 15L17.5 7.5H12.5V0H7.5ZM0 17.5V20H20V17.5H0Z" fill="#ffffff" />
        </svg>
      </div>
      <div class="col-10">
        Descargar
      </div>

    </div>
    <!---------------------------------------------------------->
    <div *ngIf="showDownloadModes">
      <div class="subrow" (click)='downloadReport()'>

        <div class="col-2">
          <svg width="20" height="20" viewBox="0 0 100 90" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" id="Icons_Document" overflow="hidden">
            <path
              d="M23 82 23 14 48 14 48 35 73 35 73 82 23 82ZM54 16.5 66.5 29 54 29 54 16.5ZM54 8 17 8 17 88 79 88 79 30 54 8Z"
              stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333" fill="#f2c63d" />
            <rect x="29" y="45" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333"
              fill="#f2c63d" />
            <rect x="29" y="37" width="13" height="4" stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333"
              fill="#f2c63d" />
            <rect x="29" y="53" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333"
              fill="#f2c63d" />
            <rect x="29" y="61" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333"
              fill="#f2c63d" />
            <rect x="29" y="69" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333"
              fill="#f2c63d" />
          </svg>
        </div>
        <div class="col-10">
          Informe
        </div>

      </div>

      <div class="subrow" (click)="onClickDownloadModal()">

        <div class="col-2">


          <span style="font-size: 13px;" *ngIf="downloading!=null; else Download">
            {{downloading.percentage | number:'1.0'}}%
          </span>
          <ng-template #Download>
            <svg width="20" height="20" viewBox="1 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
                stroke="#f2c63d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z"
                stroke="#f2c63d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </ng-template>


          <!--<svg width="20" height="20" viewBox="1 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
              stroke="#f2c63d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z"
              stroke="#f2c63d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>-->
        </div>
        <div class="col-10">
          Imágenes médicas + informe
        </div>

      </div>


      <!--<div class="subrow" (click)='showDownloadModes=false'>

        <div class="col-2">
          <svg width="20" height="20" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="10 0 100 100">
            <path fill="#f2c63d"
              d="M12,73.51q.2-34.74.39-69.38A3.21,3.21,0,0,1,15,1h0C23.4-.75,36.64-.31,45.63,3.14a35.46,35.46,0,0,1,16,11.65,37.34,37.34,0,0,1,16-11.15C86.12.4,99-.38,108.23,1A3.2,3.2,0,0,1,111,4.14h0V73.8A3.21,3.21,0,0,1,107.77,77a3.49,3.49,0,0,1-.74-.09A53.45,53.45,0,0,0,83.58,79.1a71,71,0,0,0-15.77,8.26,69.09,69.09,0,0,1,21.24-3.1,125.42,125.42,0,0,1,27.41,3.48V14.84h3.21a3.21,3.21,0,0,1,3.21,3.21V91.94a3.21,3.21,0,0,1-3.21,3.21,3.18,3.18,0,0,1-1-.17A121.77,121.77,0,0,0,89,90.65a61.89,61.89,0,0,0-25.76,5.26,3.39,3.39,0,0,1-3.64,0,61.86,61.86,0,0,0-25.76-5.26A121.77,121.77,0,0,0,4.24,95a3.18,3.18,0,0,1-1,.17A3.21,3.21,0,0,1,0,91.94V18.05a3.21,3.21,0,0,1,3.21-3.21H6.42v72.9a125.42,125.42,0,0,1,27.41-3.48,68.84,68.84,0,0,1,22.71,3.57A48.7,48.7,0,0,0,41,79.39c-7-2.3-17.68-3.07-25.49-2.4A3.21,3.21,0,0,1,12,74.06a5,5,0,0,1,0-.55ZM73.64,64.4a2.3,2.3,0,1,1-2.5-3.85,51.46,51.46,0,0,1,11.8-5.4,53.73,53.73,0,0,1,13-2.67,2.29,2.29,0,1,1,.25,4.58,49.42,49.42,0,0,0-11.79,2.46A46.73,46.73,0,0,0,73.64,64.4Zm.2-17.76a2.29,2.29,0,0,1-2.46-3.87,52.71,52.71,0,0,1,11.74-5.3A54.12,54.12,0,0,1,95.9,34.85a2.3,2.3,0,0,1,.25,4.59,49.3,49.3,0,0,0-11.63,2.4,48,48,0,0,0-10.68,4.8Zm.06-17.7a2.3,2.3,0,1,1-2.46-3.89,52.54,52.54,0,0,1,11.72-5.27,53.71,53.71,0,0,1,12.74-2.6,2.29,2.29,0,1,1,.25,4.58,49.35,49.35,0,0,0-11.59,2.39A47.91,47.91,0,0,0,73.9,28.94ZM51.74,60.55a2.3,2.3,0,1,1-2.5,3.85,46.73,46.73,0,0,0-10.72-4.88,49.42,49.42,0,0,0-11.79-2.46A2.29,2.29,0,1,1,27,52.48a53.73,53.73,0,0,1,13,2.67,51.46,51.46,0,0,1,11.8,5.4ZM51.5,42.77A2.29,2.29,0,0,1,49,46.64a48,48,0,0,0-10.68-4.8,49.3,49.3,0,0,0-11.63-2.4A2.3,2.3,0,0,1,27,34.85a54.12,54.12,0,0,1,12.78,2.62,52.71,52.71,0,0,1,11.74,5.3Zm-.06-17.72A2.3,2.3,0,1,1,49,28.94a47.91,47.91,0,0,0-10.66-4.79,49.35,49.35,0,0,0-11.59-2.39A2.29,2.29,0,1,1,27,17.18a53.71,53.71,0,0,1,12.74,2.6,52.54,52.54,0,0,1,11.72,5.27ZM104.56,7c-7.42-.7-18.06.12-24.73,2.65A30,30,0,0,0,64.7,21.46V81.72a76.76,76.76,0,0,1,16.72-8.66,62.85,62.85,0,0,1,23.14-2.87V7ZM58.28,81.1V21.37c-3.36-5.93-8.79-9.89-14.93-12.24-7-2.67-17.75-3.27-24.56-2.3l-.36,63.56c7.43-.27,17.69.68,24.52,2.91a54.94,54.94,0,0,1,15.33,7.8Z" />
          </svg>
        </div>
        <div class="col-10">
          Book Digital en PDF
        </div>

      </div>-->
    </div>

    <!---------------------------------------------------------->
    <div class="row" *ngIf="permissionService.hasPermission(TokenPermissions.SHARE)" (click)="onClickSharedModal()">
      <div class="col-2">
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" style="color: #ffffff !important;"
            d="M17.8746 3.57175C17.8741 3.07079 17.7684 2.57551 17.5642 2.11804C17.3601 1.66057 17.0621 1.25111 16.6895 0.916215C16.3169 0.581323 15.8781 0.328472 15.4015 0.17406C14.925 0.0196478 14.4213 -0.0328792 13.9231 0.0198851C13.4249 0.0726494 12.9434 0.229527 12.5097 0.480346C12.0761 0.731164 11.7 1.07032 11.4059 1.47583C11.1117 1.88134 10.9061 2.34415 10.8023 2.83424C10.6985 3.32433 10.6988 3.83076 10.8033 4.3207L6.27117 6.58633C5.80484 6.05072 5.18954 5.66614 4.50375 5.48163C3.81797 5.29712 3.09276 5.32105 2.42063 5.55036C1.74849 5.77967 1.15989 6.20397 0.729868 6.76916C0.299851 7.33434 0.0479121 8.0148 0.00617938 8.72375C-0.0355533 9.43269 0.134812 10.138 0.495549 10.7497C0.856286 11.3615 1.39105 11.8519 2.03164 12.1585C2.67223 12.4651 3.38961 12.5739 4.09231 12.4711C4.79501 12.3684 5.45118 12.0586 5.97713 11.5814L10.7408 13.9633C10.6598 14.8291 10.8972 15.6947 11.4085 16.3981C11.9198 17.1015 12.6699 17.5944 13.5184 17.7846C14.367 17.9747 15.2557 17.8491 16.0183 17.4312C16.7809 17.0132 17.365 16.3317 17.6613 15.5141C17.9575 14.6966 17.9457 13.7991 17.6279 12.9896C17.3101 12.1802 16.7081 11.5143 15.9348 11.1167C15.1614 10.7191 14.2696 10.6171 13.4264 10.8296C12.5832 11.0421 11.8464 11.5547 11.3539 12.2714L6.96382 10.0764C7.16914 9.46714 7.20619 8.81378 7.07107 8.18523L11.6032 5.9196C12.0813 6.46882 12.7157 6.85895 13.4216 7.03779C14.1275 7.21663 14.8711 7.17566 15.5531 6.92035C16.235 6.66505 16.8227 6.20759 17.2376 5.60917C17.6525 5.01075 17.8747 4.29992 17.8746 3.57175Z"
            fill="#ffffff" />
        </svg>
      </div>
      <div class="col-10">
        Compartir
      </div>
    </div>

    <div class="row " (click)='showInfoModal()'>
      <div class="col-2">
        <svg width="20" height="20" viewBox="0 0 20 24" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_331_1122)">
            <path
              d="M12 0C10.0222 0 8.08879 0.58649 6.4443 1.6853C4.79981 2.78412 3.51809 4.3459 2.76121 6.17316C2.00433 8.00043 1.8063 10.0111 2.19215 11.9509C2.578 13.8907 3.53041 15.6725 4.92894 17.0711C6.32746 18.4696 8.10929 19.422 10.0491 19.8078C11.9889 20.1937 13.9996 19.9957 15.8268 19.2388C17.6541 18.4819 19.2159 17.2002 20.3147 15.5557C21.4135 13.9112 22 11.9778 22 10C22 7.34783 20.9464 4.80429 19.0711 2.92893C17.1957 1.05357 14.6522 0 12 0V0ZM14.1059 18.0529H9.89412V7.94706H14.1059V18.0529ZM12 6.68235C11.5835 6.68235 11.1763 6.55884 10.83 6.32745C10.4837 6.09605 10.2138 5.76715 10.0544 5.38236C9.89503 4.99756 9.85333 4.57413 9.93458 4.16563C10.0158 3.75713 10.2164 3.3819 10.5109 3.08739C10.8054 2.79287 11.1807 2.59231 11.5892 2.51105C11.9977 2.4298 12.4211 2.4715 12.8059 2.63089C13.1907 2.79028 13.5196 3.06019 13.751 3.4065C13.9824 3.75281 14.1059 4.15997 14.1059 4.57647C14.1059 5.13498 13.884 5.67062 13.4891 6.06555C13.0942 6.46048 12.5585 6.68235 12 6.68235Z"
              fill="#ffffff" />
          </g>
        </svg>
      </div>
      <div class="col-10">
        Mas información
      </div>
    </div>

    <div class="row " (click)='showHistoricModal()'>
      <div class="col-2">
        <svg width="20" height="20" viewBox="0 0 20 24" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.6314 17.8446L17.2362 15.4494C17.1581 15.3713 17.0521 15.3274 16.9416 15.3274C16.8311 15.3274 16.7252 15.3713 16.647 15.4494L16.3428 15.7536L15.7199 15.1307C16.1579 14.608 16.474 13.9943 16.6454 13.3343H17.0846C17.1951 13.3343 17.3011 13.2904 17.3792 13.2122C17.4573 13.1341 17.5012 13.0281 17.5012 12.9176V0.416696C17.5012 0.306182 17.4573 0.200193 17.3792 0.122048C17.3011 0.0439018 17.1951 0 17.0846 0C13.5272 0 9.94446 0.774222 8.75062 2.46893C7.55679 0.774222 3.97403 0 0.416696 0C0.306182 0 0.200193 0.0439018 0.122048 0.122048C0.0439018 0.200193 0 0.306182 0 0.416696L0 12.9176C0 13.0281 0.0439018 13.1341 0.122048 13.2122C0.200193 13.2904 0.306182 13.3343 0.416696 13.3343C0.700883 13.3343 0.978681 13.3375 1.25009 13.3439V16.2512C1.25019 16.3203 1.2675 16.3883 1.30045 16.4491C1.33339 16.5099 1.38094 16.5615 1.43882 16.5993C1.49669 16.6372 1.56306 16.66 1.63196 16.6658C1.70085 16.6715 1.7701 16.6601 1.83346 16.6324C3.20856 16.0278 7.08384 14.7573 8.45477 16.1291C8.51304 16.1874 8.5873 16.2271 8.66815 16.2432C8.749 16.2593 8.83281 16.251 8.90897 16.2195C8.91814 16.2157 8.92522 16.2087 8.93439 16.2041V16.2074L9.46234 15.9432C10.2985 16.5384 11.3085 16.8394 12.334 16.799C13.3596 16.7585 14.3427 16.379 15.1294 15.7199L15.7524 16.3428L15.4482 16.647C15.3701 16.7252 15.3262 16.8311 15.3262 16.9416C15.3262 17.0521 15.3701 17.1581 15.4482 17.2362L17.8429 19.631C18.0798 19.868 18.4012 20.0012 18.7363 20.0012C18.9022 20.0013 19.0665 19.9686 19.2198 19.9052C19.3731 19.8417 19.5124 19.7487 19.6297 19.6314C19.7471 19.5141 19.8402 19.3748 19.9037 19.2216C19.9672 19.0683 20 18.904 20 18.7381C20 18.5722 19.9674 18.4079 19.9039 18.2546C19.8405 18.1013 19.7474 17.962 19.6302 17.8446H19.6314ZM9.16732 3.75027C9.16732 2.1389 12.363 0.911732 16.6679 0.837143V11.0575C16.4826 10.2886 16.1041 9.57969 15.5682 8.99803C15.0323 8.41637 14.3567 7.98119 13.6055 7.73371C12.8544 7.48624 12.0524 7.43467 11.2757 7.5839C10.499 7.73313 9.77331 8.07821 9.16732 8.58645V3.75027ZM0.833393 12.5034V0.835893C5.13828 0.911732 8.33393 2.1389 8.33393 3.75027V9.50068C7.90348 10.1169 7.62968 10.8287 7.53623 11.5745C7.44279 12.3203 7.53251 13.0776 7.79764 13.781C6.0696 12.7713 3.05647 12.5284 0.833393 12.5034ZM2.08348 15.634V13.376C4.96119 13.521 6.99717 14.0527 7.86514 14.8677C5.98168 14.3077 3.26857 15.1848 2.08348 15.634ZM14.8506 14.8506C14.2262 15.4752 13.4045 15.8638 12.5256 15.9504C11.6467 16.037 10.7649 15.8162 10.0306 15.3255C9.29624 14.8349 8.75474 14.1048 8.49834 13.2597C8.24194 12.4146 8.28651 11.5067 8.62445 10.6907C8.9624 9.87479 9.5728 9.20126 10.3517 8.78491C11.1305 8.36856 12.0297 8.23515 12.8959 8.40741C13.7621 8.57967 14.5417 9.04695 15.102 9.72962C15.6623 10.4123 15.9686 11.2681 15.9686 12.1513C15.9701 12.6528 15.872 13.1496 15.6801 13.613C15.4882 14.0763 15.2062 14.497 14.8506 14.8506ZM17.84 18.448L16.3345 16.9416L16.9429 16.3332L18.4492 17.84L17.84 18.448ZM19.043 19.043C18.9613 19.1214 18.8523 19.1652 18.739 19.1652C18.6258 19.1652 18.5168 19.1214 18.4351 19.043L18.4305 19.0384L19.0384 18.4305L19.0434 18.4351C19.0834 18.475 19.1151 18.5224 19.1367 18.5745C19.1583 18.6267 19.1695 18.6826 19.1695 18.739C19.1695 18.7955 19.1583 18.8514 19.1367 18.9036C19.1151 18.9557 19.0834 19.0031 19.0434 19.043H19.043Z"
          fill="#ffffff" />
        <path
          d="M10.0601 10.0603L10.6493 10.6495C11.0477 10.2516 11.5879 10.028 12.151 10.028C12.7142 10.028 13.2543 10.2516 13.6528 10.6495L14.242 10.0603C13.6873 9.50613 12.9352 9.19482 12.151 9.19482C11.3669 9.19482 10.6148 9.50613 10.0601 10.0603Z"
          fill="#ffffff" />
        <path d="M1.66699 1.66675H2.50038V4.16693H1.66699V1.66675Z" fill="#ffffff" />
        <path d="M1.66699 5.00024H2.50038V5.83364H1.66699V5.00024Z" fill="#ffffff" />
        <defs>
          <linearGradient id="paint0_linear_269_490" x1="10" y1="0" x2="10" y2="20.0012" gradientUnits="userSpaceOnUse">
            <stop stop-color="#1DDF99" />
            <stop offset="1" stop-color="#03E8E5" />
          </linearGradient>
          <linearGradient id="paint1_linear_269_490" x1="12.151" y1="9.19482" x2="12.151" y2="10.6495"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1DDF99" />
            <stop offset="1" stop-color="#03E8E5" />
          </linearGradient>
          <linearGradient id="paint2_linear_269_490" x1="2.08369" y1="1.66675" x2="2.08369" y2="4.16693"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1DDF99" />
            <stop offset="1" stop-color="#03E8E5" />
          </linearGradient>
          <linearGradient id="paint3_linear_269_490" x1="2.08369" y1="5.00024" x2="2.08369" y2="5.83364"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1DDF99" />
            <stop offset="1" stop-color="#03E8E5" />
          </linearGradient>
        </defs>
      </svg>
      </div>
      <div class="col-10">
        Histórico
      </div>
    </div>

    <div class="row " (click)='initTour()'>
      <div class="col-2">
        <svg width="30" height="30" viewBox="8 0 35 40" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M28.3332 15.0001C28.3332 12.7899 27.4552 10.6703 25.8924 9.10752C24.3296 7.54472 22.21 6.66675 19.9998 6.66675C17.7897 6.66675 15.6701 7.54472 14.1073 9.10752C12.5445 10.6703 11.6665 12.7899 11.6665 15.0001C11.6665 15.4421 11.8421 15.866 12.1547 16.1786C12.4672 16.4912 12.8911 16.6667 13.3332 16.6667C13.7752 16.6667 14.1991 16.4912 14.5117 16.1786C14.8242 15.866 14.9998 15.4421 14.9998 15.0001C14.9998 14.0112 15.2931 13.0445 15.8425 12.2222C16.3919 11.4 17.1728 10.7591 18.0864 10.3807C19 10.0022 20.0054 9.90323 20.9753 10.0962C21.9452 10.2891 22.8361 10.7653 23.5354 11.4645C24.2346 12.1638 24.7108 13.0547 24.9038 14.0246C25.0967 14.9945 24.9977 15.9999 24.6192 16.9135C24.2408 17.8271 23.5999 18.608 22.7777 19.1574C21.9554 19.7068 20.9887 20.0001 19.9998 20.0001C19.5578 20.0001 19.1339 20.1757 18.8213 20.4882C18.5088 20.8008 18.3332 21.2247 18.3332 21.6667V25.0001C18.3332 25.4421 18.5088 25.866 18.8213 26.1786C19.1339 26.4912 19.5578 26.6667 19.9998 26.6667C20.4419 26.6667 20.8658 26.4912 21.1783 26.1786C21.4909 25.866 21.6665 25.4421 21.6665 25.0001V23.1667C23.5488 22.7825 25.2405 21.7598 26.4553 20.2716C27.6702 18.7834 28.3336 16.9212 28.3332 15.0001Z"
            fill="#ffffff" />
          <path
            d="M20.0002 33.3333C20.9206 33.3333 21.6668 32.5871 21.6668 31.6667C21.6668 30.7462 20.9206 30 20.0002 30C19.0797 30 18.3335 30.7462 18.3335 31.6667C18.3335 32.5871 19.0797 33.3333 20.0002 33.3333Z"
            fill="#ffffff" />
        </svg>
      </div>
      <div class="col-10">
        Ayuda
      </div>
    </div>

    


    <span class="prp-icons" *ngIf="company==Company.M3M && (isPageSmall && !isPageVertical)"
      style="font-size: 20px; color:#2AA5F5!important;position: relative;margin-left: 35%;top: 25px;">
      <img src="assets/img/Logo Vertical.svg" style="height: 30px;">
    </span>

  </div>


  <hr *ngIf="(isPageSmall && isPageVertical)" style="width: 100% ; padding: 0px !important; opacity: 0.7;">

  <app-share-study-mobile (sendMail)="sendMail($event)" (downloadReport)="downloadReport()"></app-share-study-mobile>
  <app-download-modal-mobile (ondDownloadStudy)="downloadStudy()"></app-download-modal-mobile>
  <app-historical-modal-mobile [token]="token"></app-historical-modal-mobile>
  <app-info-study></app-info-study>
</nav>